import { render, staticRenderFns } from "./arrow_right.vue?vue&type=template&id=c07d20b2&"
import script from "./arrow_right.vue?vue&type=script&lang=js&"
export * from "./arrow_right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports